
import { mapState } from 'vuex'
export default {
  //  隐私条款页面
  name: 'Ystk',
  components: {},
  layout: 'template-page',
  fetchOnServer: false,
  fetch() {
    this.$store.commit('setHightLightHeader', { show: false })
    this.$store.commit('setFooterInfo', { show: false })
  },
  head() {
    return {
      title: '隐私条款_问卷网',
    }
  },
  computed: {
    ...mapState(['isMobile', 'innerWidth', 'clientScrollWidth']),
    isShowHeadar() {
      const { innerWidth } = this
      return innerWidth > 640
    },
  },
  watch: {
    isShowHeadar: {
      immediate: true,
      handler(val) {
        this.handleHeaderShow(val)
      },
    },
  },
  methods: {
    // 跳转路由
    jump(url, query) {
      this.$href(url, query)
    },
    handleHeaderShow(val) {
      if (this.isMobile) return
      this.$store.commit('setHightLightHeader', { show: val })
      this.$store.commit('setFooterInfo', { show: val })
    },
  },
}
